/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Internalization constants for PhoneInput component
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.2.0
 */

import ICommonTranslationPhoneInput from '../../types/common/phoneInput';

const initTranslationPhoneInput: ICommonTranslationPhoneInput = {
    hint: '',
    mask: '+7 999 999 99 99',
    placeholder: '',
};

export default initTranslationPhoneInput;
